import React from 'react'
import { BrowserView, MobileView } from 'react-device-detect'

import {
  $DCprimaryColor,
  DcButton,
  PixelCurrency,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'
import styled from 'styled-components'
import { get } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import { IPixelFactory } from '../../../../../../decl.d'

const BillingPlanCard = () => {
  const [allPlans, setAllPlans] = React.useState([])
  const [selectedPlan, setSelectedPlan] = React.useState(null)
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)

  const readData = () => {
    showLoader(mainSectionRef)
    get('/settings/subscription-plans').subscribe((res: any) => {
      setAllPlans(res?.response.data)
      hideLoader(mainSectionRef)
    })
  }
  React.useEffect(() => {
    readData()
  }, [])
  return (
    <>
      <BrowserView>
        <PixelFlexBox
          style={{
            overflow: 'auto',
            borderRadius: '12px',
            flexWrap: 'wrap',
            gap: '10px',
          }}
          className="table-container"
          ref={mainSectionRef}
        >
          {allPlans
            .sort((a: any, b: any) => {
              return a.plan_base_price - b.plan_base_price
            })
            .map((plan: any, i: number) => {
              return (
                <PixelFlexBox
                  key={i}
                  flexDirection="column"
                  backgroundColor="#f9f9f9"
                  width="48%"
                  margin="40px 0 0 "
                  style={{
                    backgroundColor: plan.is_current
                      ? $DCprimaryColor
                      : '#f9f9f9',
                    borderRadius: plan.is_current ? '12px' : '0px',
                    color: plan.is_current && '#ffffff',
                  }}
                  className={plan.is_current && 'active'}
                >
                  <PixelFlexBox
                    margin="35px 10px 10px 25px"
                    alignItems="baseline"
                  >
                    <PixelText
                      textSize="36px"
                      customColor={plan.is_current ? '#ffffff' : '#231d4f'}
                      style={{ fontWeight: '600' }}
                    >
                      <PixelCurrency value={plan.plan_base_price} />
                    </PixelText>
                    <PixelText
                      textSize="17px"
                      customColor={plan.is_current ? '#ffffff' : '#848199'}
                      style={{
                        marginLeft: '5px',
                        lineHeight: '23px',
                        fontWeight: '500',
                      }}
                    >
                      /month
                    </PixelText>
                  </PixelFlexBox>
                  <PixelDiv margin="15px 0 8px 30px">
                    <PixelText
                      customColor={plan.is_current ? '#ffffff' : '#231d4f'}
                      textSize="25px"
                      style={{ fontWeight: '500', lineHeight: '28px' }}
                    >
                      {plan.plan_name}
                    </PixelText>
                  </PixelDiv>
                  <PixelFlexBox flexDirection="column">
                    <PixelFlexBox margin="10px 0 0 30px">
                      <PixelFlexBox
                        width="20px"
                        height="20px"
                        backgroundColor="rgba(82, 67, 194, 0.103693)"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="center"
                        style={{ borderRadius: '50%' }}
                      >
                        <CheckIcon
                          color={plan.is_current ? '#ffffff' : '#000000'}
                          size={18}
                        />
                      </PixelFlexBox>
                      <PixelDiv width="70%" padding="0 5px 0 0">
                        Orders Limit: {plan.plan_orders_limit || 'No Limit'}
                      </PixelDiv>
                    </PixelFlexBox>
                    <PixelFlexBox margin="10px 0 0 30px">
                      <PixelFlexBox
                        width="20px"
                        height="20px"
                        backgroundColor="rgba(82, 67, 194, 0.103693)"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="center"
                        style={{ borderRadius: '50%' }}
                      >
                        <CheckIcon
                          color={plan.is_current ? '#ffffff' : '#000000'}
                          size={18}
                        />
                      </PixelFlexBox>
                      <PixelDiv width="70%" padding="0 5px 0 0">
                        Charges Per Order After Limit:{' '}
                        <PixelCurrency
                          value={plan.plan_additional_usage_price_per_order}
                        />
                      </PixelDiv>
                    </PixelFlexBox>
                  </PixelFlexBox>
                  <PixelFlexBox
                    justifyContent="space-around"
                    margin="15px 0"
                    alignItems="center"
                  >
                    <Button
                      className={plan.is_current && 'active'}
                      disabled={true}
                    >
                      {plan.is_current === true
                        ? 'Your Current Plan'
                        : 'Update Plan'}
                    </Button>
                  </PixelFlexBox>
                </PixelFlexBox>
              )
            })}
        </PixelFlexBox>
      </BrowserView>
      <MobileView>
        <PixelFlexBox flexDirection="column" margin="40px 0 0" padding="10px 0">
          {allPlans
            .sort((a: any, b: any) => {
              return a.plan_base_price - b.plan_base_price
            })
            .map((plan: any) => {
              return (
                <>
                  <PixelFlexBox
                    alignItems="center"
                    margin="0 0 10px"
                    padding="10px"
                    style={{
                      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.2)',
                      borderRadius: '12px',
                      minHeight: '50px',
                      backgroundColor: plan.is_current
                        ? $DCprimaryColor
                        : '#f9f9f9',
                      color: plan.is_current && '#ffffff',
                    }}
                    onClick={() => setSelectedPlan(plan)}
                    className={plan.is_current && 'active'}
                    isSelected={
                      selectedPlan && selectedPlan.plan_name === plan.plan_name
                    }
                  >
                    <PixelDiv
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        lineHeight: '19px',
                        color: plan.is_current ? '#ffffff' : '#231d4f',
                      }}
                    >
                      {plan.plan_name}
                    </PixelDiv>
                    <PixelFlexBox alignItems="flex-end">
                      <PixelText
                        color={plan.is_current ? '#fff' : '#231d4f'}
                        style={{
                          fontWeight: '600',
                        }}
                        textSize="16px"
                      >
                        <PixelCurrency value={plan.plan_base_price} />
                      </PixelText>
                      <PixelText
                        textSize="12px"
                        color={plan.is_current ? '#fff' : '#848199'}
                        style={{
                          marginLeft: '5px',
                          fontWeight: ' 500',
                        }}
                      >
                        /month
                      </PixelText>
                    </PixelFlexBox>
                  </PixelFlexBox>
                </>
              )
            })}
        </PixelFlexBox>
        {selectedPlan && (
          <PixelFlexBox
            flexDirection="column"
            padding="10px"
            margin="0 0 10px"
            style={{ borderRadius: '12px' }}
          >
            <PixelDiv
              style={{
                fontWeight: '500',
                fontSize: '16px',
                lineHeight: '19px',
                color: '#231d4f',
                marginLeft: '10px',
              }}
            >
              {selectedPlan.plan_name}
            </PixelDiv>
            <PixelFlexBox flexDirection="row" alignItems="flex-end">
              <PixelText
                color={plan.is_current ? '#fff' : '#231d4f'}
                style={{
                  fontWeight: '600',
                }}
                textSize="16px"
              >
                <PixelCurrency value={selectedPlan.plan_base_price} />
              </PixelText>
              <PixelText
                textSize="12px"
                color={plan.is_current ? '#fff' : '#848199'}
                style={{
                  marginLeft: '5px',
                  fontWeight: ' 500',
                }}
              >
                /month
              </PixelText>
            </PixelFlexBox>
            <PixelFlexBox
              flexDirection="column"
              margin="10px 0"
              alignItems="flex-start"
            >
              <PixelDiv alignItems="center" margin="10px 0">
                <PixelFlexBox
                  width="20px"
                  height="20px"
                  backgroundColor="rgba(82, 67, 194, 0.103693)"
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{ borderRadius: '50%' }}
                >
                  <CheckIcon
                    size={18}
                    color={
                      selectedPlan && selectedPlan.is_current
                        ? '#ffffff'
                        : '#000000'
                    }
                  />
                </PixelFlexBox>
                <PixelDiv width="70%" padding="0 0 5px">
                  Orders Limit: {selectedPlan.plan_orders_limit || 'No Limit'}
                </PixelDiv>
              </PixelDiv>
              <PixelDiv alignItems="center" margin="10px 0">
                <PixelFlexBox
                  width="20px"
                  height="20px"
                  backgroundColor="rgba(82, 67, 194, 0.103693)"
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{ borderRadius: '50%' }}
                >
                  <CheckIcon
                    size={18}
                    color={
                      selectedPlan && selectedPlan.is_current
                        ? '#ffffff'
                        : '#000000'
                    }
                  />
                </PixelFlexBox>
                <PixelDiv width="70%" padding="0 0 5px">
                  Charges Per Order After Limit:{' '}
                  <PixelCurrency
                    value={selectedPlan?.plan_additional_usage_price_per_order}
                  />
                </PixelDiv>
              </PixelDiv>
            </PixelFlexBox>
            <PixelFlexBox
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              margin="10px 0"
            >
              <Button
                onClick={() => setSelectedPlan(plan)}
                className={selectedPlan.is_current && 'active'}
                disabled={selectedPlan.is_current}
              >
                {selectedPlan.is_current === true
                  ? 'Your Current Plan'
                  : 'Update Plan'}
              </Button>
            </PixelFlexBox>
          </PixelFlexBox>
        )}
      </MobileView>
    </>
  )
}

const Button = styled(DcButton)`
  &.active {
    border: 1px solid #ffffff !important;
    color: #ffffff;
    opacity: 1 !important;
  }
`

export default BillingPlanCard
